import React from 'react';
import { Chip } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import type { AdvisorySourceQuote } from './advisoryProvenance';

export const quoteLabelTone = (status: AdvisorySourceQuote['status']) =>
  status === 'absent'
    ? 'error'
    : status === 'unchecked'
    ? 'warning'
    : status === 'verified'
    ? 'success'
    : undefined;

export const quoteLabelColor = (theme: Theme, tone: ReturnType<typeof quoteLabelTone>) =>
  tone === 'error'
    ? theme.colors.vermilion
    : tone === 'warning'
    ? theme.colors.warning
    : tone === 'success'
    ? theme.palette.success.dark
    : theme.colors.lavenderDeep;

export function AdvisoryQuoteLabel({
  label,
  current = false,
  monospace = true,
  tone,
}: {
  label: string;
  current?: boolean;
  monospace?: boolean;
  tone?: ReturnType<typeof quoteLabelTone>;
}) {
  return (
    <Chip
      component="span"
      label={label}
      aria-current={current ? 'location' : undefined}
      size="small"
      variant="outlined"
      sx={theme => {
        const color = quoteLabelColor(theme, tone);
        return {
          flexShrink: 0,
          color,
          borderColor: color,
          fontFamily: monospace ? theme.visualPrimitives.monoStack : theme.typography.fontFamily,
          fontWeight: 500,
        };
      }}
    />
  );
}
